import { createSelector } from 'reselect';
import { IActivityLogState } from 'src/app/interfaces/IActivityLog';
import { getLogUsersEmails, getSubTypes } from './helpers';
import { IState } from '../../core/redux/interfaces';
import 'core-js/features/set';

export const getState = (state: IState): IActivityLogState =>
  state.activityLog || {};

export const getAppliedFilters = createSelector(
  [getState],
  ({ appliedFilters }) => appliedFilters
);

export const getActivityLogData = createSelector(
  [getState],
  ({ activityLogData }) => activityLogData
);

export const getIsActivityLogFilterDrawerVisible = createSelector(
  [getState],
  ({ isActivityLogFilterDrawerVisible }) => isActivityLogFilterDrawerVisible
);

export const getInitialDrawerFilters = createSelector(
  [getState],
  ({ initialDrawerFilters }) => initialDrawerFilters
);

export const getUserSelectedDrawerFilters = createSelector(
  [getState],
  ({ userSelectedDrawerFilters }) => userSelectedDrawerFilters
);

export const getIsUserTouchedFilters = createSelector(
  [getState],
  ({ hasUserTouchedFilters }) => hasUserTouchedFilters
);

export const getDrawerSubtypesOptions = createSelector(
  [getState],
  ({ userSelectedDrawerFilters }) =>
    getSubTypes(userSelectedDrawerFilters.userSelectedEventSubTypes)
);

export const getLogUsersOptions = createSelector(
  [getState],
  ({ activityLogData, userSelectedDrawerFilters }) =>
    getLogUsersEmails(
      activityLogData.data.logs,
      userSelectedDrawerFilters.userSelectedUsers
    )
);

export const getActivityLogsRequestDate = createSelector(
  [getState],
  ({ activityLogRequestDate }) => {
    if (activityLogRequestDate.length === 0) {
      return {
        date: '',
        time: '',
      };
    }
    return {
      date: activityLogRequestDate.split('T')[0],
      time: activityLogRequestDate.split('T')[1].slice(0, 8),
    };
  }
);
